module.exports = __webpack_public_path__ + "static/media/ExportIcon.6fb4220d.svg";